import React, { useEffect, useState } from 'react';
import { API_BASE_URL, Left_Icon_Color, Menu_Back_Color, Menu_Close_Drawer_Color, Menu_Hover_Color, Menu_List_Text_Color, Menu_Open_Drawer_Color, Menu_Text_Color } from '../constant/constant';
import {
  AppBar, Toolbar, Typography, IconButton, Menu, MenuItem,
  Box, Tooltip, Drawer, List, ListItem, ListItemText,
  Divider
} from '@mui/material';
import {
  AccountCircle, Brightness4, Brightness7, Menu as MenuIcon
} from '@mui/icons-material';
import '../css/App.css';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { decrypt } from '../components/cryptoUtil';
import axios from 'axios';
import SessionManager from '../components/SessionManager';
import { useNavigate } from 'react-router-dom';


axios.defaults.withCredentials = true; // send cookies


function Header({ firmName, logoUrl, username, menuItems = [], onMenuSelect, drawerOpen, setDrawerOpen, darkMode, setDarkMode }) {
  const [anchorEl, setAnchorEl] = useState(null);
  //const refreshSession = useSessionRefresher();
const navigate = useNavigate();
  const [remaining, setRemaining] = useState(null);
  //const [darkMode, setDarkMode] = useState(false);
  //const [drawerOpen, setDrawerOpen] = useState(false);
  const [expandedMenu, setExpandedMenu] = useState(null); // or useState('Reports') to default open



  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const toggleDrawer = (open) => () => setDrawerOpen(open);
  const [reportsExpanded, setReportsExpanded] = useState(false);
  const handleMenuClick = (item) => {
    onMenuSelect(item);
    setDrawerOpen(false);
  };



  const options = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata'
  };


  const decryptedData = JSON.parse(decrypt(localStorage.getItem('tokenData')));
  //console.log(decryptedData);
  const lastLoginTime = decryptedData.lastlogintime;
  const formatteddate = new Date(lastLoginTime).toLocaleString('en-IN', options);
  const userfullname = (JSON.parse(decrypt(localStorage.getItem('tokenData'))).userfullname);


//console.log(decrypt(localStorage.getItem('tokenData')));





// replace single expandedMenu state
const [expandedMenus, setExpandedMenus] = useState(new Set());

// toggle expansion for any menu item
const toggleExpand = (label) => {
  setExpandedMenus((prev) => {
    const newSet = new Set(prev);
    if (newSet.has(label)) {
      newSet.delete(label);   // collapse
    } else {
      newSet.add(label);      // expand
    }
    return newSet;
  });
};

const renderMenuItems = (items, level = 0) => {
  return items.map((item) => (
    <React.Fragment key={item.label}>
      <ListItem
        button
        onClick={() => {
          if (item.children) {
            toggleExpand(item.label);
          } else {
            handleMenuClick(item.label);
          }
        }}
        sx={{
          pl: 2 + level * 2,
          '&:hover': { backgroundColor: Menu_Hover_Color },
          py: 0.5,
        }}
      >
        {item.icon && <Box sx={{ mr: 1 }}>{item.icon}</Box>}
        <ListItemText
          primary={item.label}
          primaryTypographyProps={{
            sx: { fontSize: { xs: '0.7rem', sm: '1rem' }, color: Menu_List_Text_Color },
          }}
        />
        {item.children &&
          (expandedMenus.has(item.label) ? (
            <ExpandLessIcon sx={{ color: Menu_Open_Drawer_Color }} />
          ) : (
            <ExpandMoreIcon sx={{ color: Menu_Close_Drawer_Color }} />
          ))}
      </ListItem>

      {/* Recursive render for children */}
      {item.children && expandedMenus.has(item.label) && renderMenuItems(item.children, level + 1)}
    </React.Fragment>
  ));
};









  const handleLogout = async () => {

    try {
      const token = localStorage.getItem("token");
      if (token) {
        await axios.post(`${API_BASE_URL}/logout`, {}, {
          headers: { Authorization: `Bearer ${token}` },
        });
      }
    } catch (_) {
      // ignore network errors on logout
    } finally {
          navigate("/", { replace: true });
          localStorage.setItem('isAuthenticated', 'false');
          localStorage.clear();
          sessionStorage.clear();

    }
  };


  const WhiteDivider = <Divider sx={{ backgroundColor: "white", my: 1 }} />;

  return (
    <>

      <AppBar position="static"
        // elevation={40} // higher number = deeper shadow
        sx={{
          backgroundColor: Menu_Back_Color,
          color: Menu_Text_Color,
          borderRadius: 2,          // 👈  theme.spacing(2) → 16px rounding
          // 👈  theme.spacing(2) → 16px rounding
          //margin: 2,                // 👈 spacing from edges
          width: 'auto',            // 👈 so it doesn't stick full screen
          // px: 2,                    // 👈 padding left & right
        }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>

          {/* Menu Toolbar */}

          <Tooltip title={'Select Menu'}>
            <IconButton color="inherit" onClick={toggleDrawer(true)} sx={{ mr: 1 }}>
              <MenuIcon />
            </IconButton>
          </Tooltip>


          <Box display="flex" >
            {/* Logo hidden on extra-small screens */}


            {/* {logoUrl && (
              <Box
                component="img"
                src={logoUrl}
                alt="Logo"
                sx={{
                  height: 35,
                  marginRight: 2,
                  display: { xs: 'none', sm: 'block' } // Hide on xs (mobile)
                }}
              />
            )} */}



            <Typography

              sx={{
                fontSize: { xs: '1rem', sm: '1.25rem' }, // Smaller on mobile
                fontWeight: 400
              }}
            >
              {firmName}
            </Typography>
          </Box>

          {/* Right: Dark Mode + User */}
          <Box display="flex" alignItems="center">

           
            <SessionManager />







            <Tooltip title={<>{userfullname} <br /><br />   Last Login : {''} {formatteddate}</>}>
              <IconButton color="inherit" onClick={handleMenuOpen}><AccountCircle sx={{ color: Left_Icon_Color }} /></IconButton>
            </Tooltip>


            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              MenuListProps={{
                sx: {
                  backgroundColor: Menu_Back_Color,
                  color: Menu_Text_Color,
                  '& .MuiMenuItem-root:not(.logout-item)': {
                    '&:hover': {
                      backgroundColor: Menu_Hover_Color, // default hover color
                    },
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  //alert('User Details');
                  onMenuSelect('User Details');
                  handleMenuClose();
                }}
              >
                <AccountBoxIcon sx={{ mr: 1, fontSize: '1.2rem', color: Left_Icon_Color }} />
                User Details
              </MenuItem>
              <MenuItem
                onClick={() => {
                  onMenuSelect('Change Password');
                  handleMenuClose();
                }}
              >
                <ManageAccountsIcon sx={{ mr: 1, fontSize: '1.2rem', color: Left_Icon_Color }} />
                Change Password
              </MenuItem>

              <MenuItem
                className="logout-item"
                onClick={() => { handleLogout(); }}
                sx={{
                  '&.logout-item:hover': {
                    backgroundColor: '#ff4d4f', // red hover for Logout
                  },
                }}
              >
                <LogoutIcon sx={{ mr: 1, fontSize: '1.2rem', color: 'red' }} />
                Logout
              </MenuItem>



            </Menu>






          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer
        anchor="left"          //// drawwer side left oe right
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            top: { xs: '56px', sm: '72px' },
            //  height: 'calc(100% - 72px)',
            maxHeight: 'auto', // Let it grow based on content
            backgroundColor: Menu_Back_Color,
            color: Menu_Text_Color,
            left: "8px"    //// drawwer space left oe right

          },
        }}
      >
        <Box
          sx={{
           // width: { xs: '75%', sm: 250 }, // 50% width on mobile, 250px on larger screens
            pr: '20px',
            backgroundColor: Menu_Back_Color, // dark background
            color: Menu_Text_Color, // text color
            marginBottom: '100px',
            marginTop: '10px'
          }}
          role="presentation"
        >

        <List>
  {renderMenuItems(menuItems)}
</List>







        </Box>

      </Drawer>
    </>
  );
}

export default Header;
